__webpack_require__.p = "https://wscc-usertask-service-dev.wscc-dev-dmz.prj.gcp.wellsky.io/";